import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { XIcon } from 'lucide-react';
function LegalModal({
  title,
  children,
  onClose
}: {
  title: string;
  children: React.ReactNode;
  onClose: () => void;
}) {
  return <AnimatePresence data-id="element-33">
      <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} exit={{
      opacity: 0
    }} className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/80 backdrop-blur-sm" onClick={onClose} data-id="element-34">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95,
        y: 20
      }} animate={{
        opacity: 1,
        scale: 1,
        y: 0
      }} exit={{
        opacity: 0,
        scale: 0.95,
        y: 20
      }} transition={{
        duration: 0.3
      }} className="bg-dark-800 border border-gold-500/20 rounded-2xl max-w-3xl w-full max-h-[85vh] overflow-y-auto p-8 md:p-10 relative" onClick={e => e.stopPropagation()} data-id="element-35">
          <button onClick={onClose} className="absolute top-4 right-4 text-gray-400 hover:text-white transition-colors" data-id="element-36">
            <XIcon className="w-6 h-6" data-id="element-37" />
          </button>
          <h2 className="text-2xl md:text-3xl font-serif text-gold-500 mb-8" data-id="element-38">
            {title}
          </h2>
          <div className="text-gray-300 text-sm leading-relaxed space-y-6" data-id="element-39">
            {children}
          </div>
        </motion.div>
      </motion.div>
    </AnimatePresence>;
}
export function Footer() {
  const [activeModal, setActiveModal] = useState<'terms' | 'privacy' | null>(null);
  return <>
      <footer className="bg-dark-900 py-8 border-t border-white/5 text-center px-4" data-id="element-40">
        <div className="max-w-4xl mx-auto" data-id="element-41">
          <p className="text-gray-500 text-sm" data-id="element-42">
            &copy; {new Date().getFullYear()} El Anti-Manual de la IA. Todos los
            derechos reservados.
          </p>
          <div className="mt-4 flex justify-center space-x-6 text-xs text-gray-600" data-id="element-43">
            <button onClick={() => setActiveModal('terms')} className="hover:text-gold-500 transition-colors" data-id="element-44">
              Términos y Condiciones
            </button>
            <button onClick={() => setActiveModal('privacy')} className="hover:text-gold-500 transition-colors" data-id="element-45">
              Política de Privacidad
            </button>
            <a href="#" className="hover:text-gold-500 transition-colors" data-id="element-46">
              Contacto
            </a>
          </div>
        </div>
      </footer>

      {activeModal === 'terms' && <LegalModal title="Términos y Condiciones" onClose={() => setActiveModal(null)} data-id="element-47">
          <p className="text-gray-400 text-xs italic" data-id="element-48">
            Última actualización: abril 2026
          </p>

          <div data-id="element-49">
            <h3 className="text-white font-semibold mb-2" data-id="element-50">
              1. Aceptación de los Términos
            </h3>
            <p data-id="element-51">
              Al acceder a este sitio web y/o adquirir el producto digital "El
              Anti-Manual de la IA" (en adelante, "el Producto"), aceptas
              cumplir con estos Términos y Condiciones en su totalidad. Si no
              estás de acuerdo con alguna de estas condiciones, te rogamos que
              no realices la compra ni utilices este sitio.
            </p>
          </div>

          <div data-id="element-52">
            <h3 className="text-white font-semibold mb-2" data-id="element-53">
              2. Descripción del Producto
            </h3>
            <p data-id="element-54">
              El Producto es un paquete de contenido digital educativo que
              incluye guías en formato PDF, plantillas, checklists y materiales
              complementarios. No constituye asesoría profesional, legal,
              financiera ni laboral personalizada. Los resultados pueden variar
              según la aplicación individual de cada usuario.
            </p>
          </div>

          <div data-id="element-55">
            <h3 className="text-white font-semibold mb-2" data-id="element-56">3. Precio y Pago</h3>
            <p data-id="element-57">
              El precio del Producto es de $7.97 USD (más impuestos aplicables
              según tu país de residencia). El pago se realiza de forma única a
              través de plataformas de pago seguras y cifradas. Una vez
              completada la transacción, recibirás acceso inmediato al contenido
              digital.
            </p>
          </div>

          <div data-id="element-58">
            <h3 className="text-white font-semibold mb-2" data-id="element-59">
              4. Entrega y Acceso
            </h3>
            <p data-id="element-60">
              Tras confirmar el pago, recibirás un enlace de descarga o acceso
              al contenido de forma inmediata por correo electrónico. Es tu
              responsabilidad proporcionar una dirección de correo electrónico
              válida y verificar tu bandeja de entrada (incluyendo la carpeta de
              spam).
            </p>
          </div>

          <div data-id="element-61">
            <h3 className="text-white font-semibold mb-2" data-id="element-62">
              5. Propiedad Intelectual
            </h3>
            <p data-id="element-63">
              Todo el contenido del Producto (textos, diseños, plantillas,
              metodologías y materiales) está protegido por derechos de autor.
              Al adquirirlo, obtienes una licencia personal e intransferible
              para uso individual. Queda estrictamente prohibido reproducir,
              distribuir, revender, compartir o modificar el contenido sin
              autorización expresa por escrito.
            </p>
          </div>

          <div data-id="element-64">
            <h3 className="text-white font-semibold mb-2" data-id="element-65">
              6. Política de Reembolso
            </h3>
            <p data-id="element-66">
              Debido a la naturaleza digital del Producto y su entrega
              inmediata, no se ofrecen reembolsos una vez completada la descarga
              o el acceso al contenido. Si experimentas problemas técnicos para
              acceder al material, contáctanos y resolveremos tu caso de forma
              individual.
            </p>
          </div>

          <div data-id="element-67">
            <h3 className="text-white font-semibold mb-2" data-id="element-68">
              7. Limitación de Responsabilidad
            </h3>
            <p data-id="element-69">
              El Producto se ofrece con fines educativos e informativos. No
              garantizamos resultados específicos derivados de su uso. En ningún
              caso seremos responsables por daños directos, indirectos,
              incidentales o consecuentes que puedan surgir del uso o la
              imposibilidad de uso del Producto.
            </p>
          </div>

          <div data-id="element-70">
            <h3 className="text-white font-semibold mb-2" data-id="element-71">8. Modificaciones</h3>
            <p data-id="element-72">
              Nos reservamos el derecho de modificar estos Términos y
              Condiciones en cualquier momento. Las modificaciones entrarán en
              vigor desde su publicación en este sitio. Es responsabilidad del
              usuario revisar periódicamente estos términos.
            </p>
          </div>

          <div data-id="element-73">
            <h3 className="text-white font-semibold mb-2" data-id="element-74">
              9. Legislación Aplicable
            </h3>
            <p data-id="element-75">
              Estos términos se regirán e interpretarán de acuerdo con las leyes
              aplicables en la jurisdicción del vendedor. Cualquier disputa será
              resuelta ante los tribunales competentes de dicha jurisdicción.
            </p>
          </div>

          <div data-id="element-76">
            <h3 className="text-white font-semibold mb-2" data-id="element-77">10. Contacto</h3>
            <p data-id="element-78">
              Si tienes preguntas sobre estos Términos y Condiciones, puedes
              contactarnos a través de la sección de Contacto de este sitio web.
            </p>
          </div>
        </LegalModal>}

      {activeModal === 'privacy' && <LegalModal title="Política de Privacidad" onClose={() => setActiveModal(null)} data-id="element-79">
          <p className="text-gray-400 text-xs italic" data-id="element-80">
            Última actualización: abril 2026
          </p>

          <div data-id="element-81">
            <h3 className="text-white font-semibold mb-2" data-id="element-82">
              1. Información que Recopilamos
            </h3>
            <p data-id="element-83">
              Cuando realizas una compra en nuestro sitio, recopilamos la
              siguiente información personal:
            </p>
            <ul className="list-disc list-inside mt-2 space-y-1 text-gray-400" data-id="element-84">
              <li data-id="element-85">Nombre completo</li>
              <li data-id="element-86">Dirección de correo electrónico</li>
              <li data-id="element-87">País de residencia (para cálculo de impuestos)</li>
              <li data-id="element-88">
                Información de pago (procesada de forma segura por terceros; no
                almacenamos datos de tarjetas)
              </li>
            </ul>
          </div>

          <div data-id="element-89">
            <h3 className="text-white font-semibold mb-2" data-id="element-90">
              2. Uso de la Información
            </h3>
            <p data-id="element-91">Utilizamos tu información personal exclusivamente para:</p>
            <ul className="list-disc list-inside mt-2 space-y-1 text-gray-400" data-id="element-92">
              <li data-id="element-93">Procesar y entregar tu compra</li>
              <li data-id="element-94">Enviarte el acceso al Producto adquirido</li>
              <li data-id="element-95">Comunicarnos contigo en caso de problemas con tu pedido</li>
              <li data-id="element-96">Cumplir con obligaciones legales y fiscales</li>
            </ul>
          </div>

          <div data-id="element-97">
            <h3 className="text-white font-semibold mb-2" data-id="element-98">
              3. Comunicaciones por Correo Electrónico
            </h3>
            <p data-id="element-99">
              Al realizar tu compra, podrás recibir correos electrónicos
              relacionados con tu pedido y contenido relevante. Puedes darte de
              baja de las comunicaciones promocionales en cualquier momento
              haciendo clic en el enlace "Cancelar suscripción" incluido en cada
              correo.
            </p>
          </div>

          <div data-id="element-100">
            <h3 className="text-white font-semibold mb-2" data-id="element-101">
              4. Protección de Datos
            </h3>
            <p data-id="element-102">
              Implementamos medidas de seguridad técnicas y organizativas para
              proteger tu información personal contra acceso no autorizado,
              alteración, divulgación o destrucción. Los pagos se procesan a
              través de plataformas certificadas con cifrado SSL/TLS.
            </p>
          </div>

          <div data-id="element-103">
            <h3 className="text-white font-semibold mb-2" data-id="element-104">
              5. Compartición con Terceros
            </h3>
            <p data-id="element-105">
              No vendemos, alquilamos ni compartimos tu información personal con
              terceros, excepto:
            </p>
            <ul className="list-disc list-inside mt-2 space-y-1 text-gray-400" data-id="element-106">
              <li data-id="element-107">
                Procesadores de pago necesarios para completar tu transacción
              </li>
              <li data-id="element-108">
                Proveedores de servicios de correo electrónico para la entrega
                del Producto
              </li>
              <li data-id="element-109">Cuando sea requerido por ley o autoridad competente</li>
            </ul>
          </div>

          <div data-id="element-110">
            <h3 className="text-white font-semibold mb-2" data-id="element-111">
              6. Cookies y Tecnologías de Seguimiento
            </h3>
            <p data-id="element-112">
              Este sitio puede utilizar cookies y tecnologías similares para
              mejorar la experiencia del usuario, analizar el tráfico del sitio
              y personalizar el contenido. Puedes configurar tu navegador para
              rechazar cookies, aunque esto podría afectar la funcionalidad del
              sitio.
            </p>
          </div>

          <div data-id="element-113">
            <h3 className="text-white font-semibold mb-2" data-id="element-114">7. Tus Derechos</h3>
            <p data-id="element-115">Tienes derecho a:</p>
            <ul className="list-disc list-inside mt-2 space-y-1 text-gray-400" data-id="element-116">
              <li data-id="element-117">Acceder a los datos personales que tenemos sobre ti</li>
              <li data-id="element-118">Solicitar la rectificación de datos inexactos</li>
              <li data-id="element-119">Solicitar la eliminación de tus datos personales</li>
              <li data-id="element-120">Oponerte al procesamiento de tus datos</li>
              <li data-id="element-121">Solicitar la portabilidad de tus datos</li>
            </ul>
            <p className="mt-2" data-id="element-122">
              Para ejercer cualquiera de estos derechos, contáctanos a través de
              la sección de Contacto.
            </p>
          </div>

          <div data-id="element-123">
            <h3 className="text-white font-semibold mb-2" data-id="element-124">
              8. Retención de Datos
            </h3>
            <p data-id="element-125">
              Conservamos tu información personal durante el tiempo necesario
              para cumplir con los fines descritos en esta política, así como
              para cumplir con nuestras obligaciones legales y fiscales.
            </p>
          </div>

          <div data-id="element-126">
            <h3 className="text-white font-semibold mb-2" data-id="element-127">
              9. Menores de Edad
            </h3>
            <p data-id="element-128">
              Este sitio y el Producto no están dirigidos a menores de 18 años.
              No recopilamos intencionalmente información de menores de edad.
            </p>
          </div>

          <div data-id="element-129">
            <h3 className="text-white font-semibold mb-2" data-id="element-130">
              10. Cambios en esta Política
            </h3>
            <p data-id="element-131">
              Nos reservamos el derecho de actualizar esta Política de
              Privacidad en cualquier momento. Los cambios se publicarán en esta
              página con la fecha de última actualización. Te recomendamos
              revisarla periódicamente.
            </p>
          </div>

          <div data-id="element-132">
            <h3 className="text-white font-semibold mb-2" data-id="element-133">11. Contacto</h3>
            <p data-id="element-134">
              Si tienes preguntas o inquietudes sobre esta Política de
              Privacidad o el tratamiento de tus datos personales, puedes
              contactarnos a través de la sección de Contacto de este sitio web.
            </p>
          </div>
        </LegalModal>}
    </>;
}